/*
 * Phone "added to cart" sheet (snippets/jc-added.liquid).
 * - Opens after an add from a product form (Dawn publishes cartUpdate with the add response)
 * - Shows the added item, cart/checkout buttons and up to 3 recommendations with one-tap add
 * - Closes on "no thanks", the close button, the backdrop, Esc or a swipe down
 * - Steps aside when the outer-sleeves upsell opens (event jc:upsell-show)
 */
(function () {
  if (window.jcAddedReady) return;
  window.jcAddedReady = true;

  var dialog = document.querySelector('[data-jc-added]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var phone = window.matchMedia('(max-width: 749px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var panel = dialog.querySelector('.jc-added__panel');
  var img = dialog.querySelector('[data-jc-added-img]');
  var name = dialog.querySelector('[data-jc-added-name]');
  var price = dialog.querySelector('[data-jc-added-price]');
  var recs = dialog.querySelector('[data-jc-added-recs]');
  var list = dialog.querySelector('[data-jc-added-list]');
  var recsUrl = dialog.dataset.recsUrl || '/recommendations/products';
  var lastFocus = null;

  // jc-motion.js shows its small toast only when this sheet is not in use.
  window.jcAddedActive = function () { return phone.matches; };

  function money(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function fetchRecs(productId, intent) {
    var url = recsUrl + '?section_id=jc-cart-recs&limit=6&intent=' + intent + '&product_id=' + productId;
    return fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('.jc-addon')).filter(function (li) {
          return li.dataset.productId !== String(productId);
        });
      })
      .catch(function () { return []; });
  }

  function loadRecs(productId) {
    recs.hidden = true;
    list.innerHTML = '';
    fetchRecs(productId, 'complementary').then(function (items) {
      return items.length >= 2 ? items : fetchRecs(productId, 'related');
    }).then(function (items) {
      if (!items.length) return;
      items.slice(0, 3).forEach(function (li) { list.appendChild(document.importNode(li, true)); });
      recs.hidden = false;
    });
  }

  function open(item) {
    if (item.image) {
      img.src = item.image + (item.image.indexOf('?') === -1 ? '?' : '&') + 'width=160';
      img.alt = item.product_title || item.title || '';
      img.hidden = false;
    } else {
      img.hidden = true;
    }
    name.textContent = item.product_title || item.title || '';
    var each = typeof item.final_price === 'number' ? item.final_price : item.price;
    price.textContent = typeof each === 'number' ? (item.quantity > 1 ? item.quantity + ' × ' : '') + money(each) : '';
    loadRecs(item.product_id);

    lastFocus = document.activeElement;
    if (!dialog.open) dialog.showModal();
    panel.focus({ preventScroll: true });
    requestAnimationFrame(function () { dialog.classList.add('is-open'); });
  }

  function close() {
    if (!dialog.open) return;
    dialog.classList.remove('is-open');
    var done = function () {
      dialog.close();
      panel.style.transform = '';
      if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    };
    if (reduceMotion) done(); else setTimeout(done, 260);
  }

  // One-tap add for the recommendations (same rows as the cart drawer).
  list.addEventListener('click', function (event) {
    var button = event.target.closest('[data-jc-addon-add]');
    if (!button || button.disabled) return;
    var spinner = button.querySelector('.loading__spinner');
    button.disabled = true;
    if (spinner) spinner.classList.remove('hidden');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.dataset.jcAddonAdd), quantity: 1 }] }),
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (result) {
        if (spinner) spinner.classList.add('hidden');
        if (!result.ok) {
          button.disabled = false;
          if (typeof publish === 'function' && PUB_SUB_EVENTS.cartError) {
            publish(PUB_SUB_EVENTS.cartError, { source: 'jc-added', errors: result.data.description || result.data.message });
          }
          return;
        }
        button.classList.add('is-added');
        button.querySelector('span').textContent = dialog.dataset.addedLabel || '✓';
        if (typeof publish === 'function' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'jc-added', cartData: result.data });
        }
      })
      .catch(function () {
        button.disabled = false;
        if (spinner) spinner.classList.add('hidden');
      });
  });

  dialog.addEventListener('click', function (event) {
    if (event.target === dialog || event.target.closest('[data-jc-added-close]')) close();
  });
  dialog.addEventListener('cancel', function (event) {
    event.preventDefault();
    close();
  });

  // Swipe down on the handle closes the sheet.
  var handle = dialog.querySelector('.jc-sheet__handle');
  var startY = null;
  handle.addEventListener('pointerdown', function (event) {
    startY = event.clientY;
    handle.setPointerCapture(event.pointerId);
  });
  handle.addEventListener('pointermove', function (event) {
    if (startY === null) return;
    panel.style.transition = 'none';
    panel.style.transform = 'translateY(' + Math.max(0, event.clientY - startY) + 'px)';
  });
  handle.addEventListener('pointerup', function (event) {
    if (startY === null) return;
    var dy = event.clientY - startY;
    startY = null;
    panel.style.transition = '';
    if (dy > 90) close();
    else panel.style.transform = '';
  });

  document.addEventListener('jc:upsell-show', close);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!phone.matches || !event || event.source !== 'product-form') return;
      var data = event.cartData;
      // An add response is a line item or { items: [...] }; a full cart (item_count) is not an add.
      if (!data || data.status || 'item_count' in data) return;
      var item = Array.isArray(data.items) ? data.items[0] : data;
      if (!item || typeof item.product_id !== 'number') return;
      // Let the outer-sleeves upsell decide first; it fires jc:upsell-show when it opens.
      setTimeout(function () {
        var upsell = document.getElementById('jc-os-upsell');
        if (upsell && !upsell.hidden) return;
        open(item);
      }, 50);
    });
  }
})();
